/*
Copyright (c) 2024, HP Development Company, L.P. All rights reserved.
This software contains confidential and proprietary information of HP.
The user of this software agrees not to disclose, disseminate or copy
such Confidential Information and shall use the software only in accordance
with the terms of the license agreement the user entered into with HP.
*/

import React from 'react';
import { AccordionProps } from './types';
import TAccordion from './Container';
import { withAnalytics } from '@veneer/analytics';
import { generateID } from '../../base/helper';

export const AccordionAnalytics = withAnalytics(TAccordion);

/**
 * UI Toolkit Accordion
 * @public
 */

const AccordionWrapper: React.FC<AccordionProps> = (props) => {
  const {
    id = generateID('clientos-ui-toolkit-accordion'),
    children,
    size,
    dividerTop,
    dividerBottom,
    behavior,
    onCollapse,
    onExpand,
    trackId,
    ...rest
  } = props;
  if (trackId) {
    return (
      <AccordionAnalytics
        {...{
          id,
          children,
          size,
          dividerTop,
          dividerBottom,
          behavior,
          onCollapse,
          onExpand,
          trackId,
          ...rest
        }}
      />
    );
  }
  return (
    <TAccordion
      {...{
        id,
        children,
        size,
        dividerTop,
        dividerBottom,
        behavior,
        onCollapse,
        onExpand
      }}
    />
  );
};

export default AccordionWrapper;
